import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Cart } from '@core/models';
import { UpsellService } from '@core/services';
import { Store } from '@ngxs/store';
import { CartState } from '@store/cart/cart.state';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

export const upsellGuard: CanActivateFn = route => {
  const upsellService = inject(UpsellService);
  const router = inject(Router);
  const store = inject(Store);
  const slug = route.paramMap.get('slug');

  return store.select(CartState.cart).pipe(
    switchMap((cart: Cart) => {
      const cartItem = cart?.items?.find(item => item.item_data?.slug === slug);

      if (!cartItem) {
        return of(router.parseUrl('/cart'));
      }

      return upsellService.checkUpsell(cart.id).pipe(
        map(res => (res.slug === slug ? true : router.parseUrl('/cart'))),
        catchError(() => of(router.parseUrl('/cart')))
      );
    }),
    catchError(() => of(router.parseUrl('/cart')))
  );
};
